module.exports = __webpack_public_path__ + "img/ltkbrasil-3x.5e81d73.jpg";